export function isSameType(a, b) {
  // we do this cause typeof can't differenciate object/ array/ null
  return Object.prototype.toString.call(a) === Object.prototype.toString.call(b);
}